"use client";

import { signIn } from "next-auth/react";

const V       = "#6768FC";
const BG      = "#0D0E17";
const SURFACE = "#1A1B26";
const BORDER  = "rgba(103,104,252,0.18)";
const TEXT     = "#F1F7F9";
const MUTED    = "#8B8FA8";

function CrossedLogo({ size = 36 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
      <path
        d="M16 2 L17.5 14.5 L30 16 L17.5 17.5 L16 30 L14.5 17.5 L2 16 L14.5 14.5 Z"
        fill={V}
      />
    </svg>
  );
}

export default function LoginPage() {
  return (
    <div style={{
      fontFamily: "var(--font-sora, var(--font-space-grotesk, sans-serif))",
      background: BG,
      minHeight: "100vh",
      color: TEXT,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      overflow: "hidden",
    }}>
      {/* Background glow */}
      <div style={{
        position: "absolute",
        top: "20%",
        left: "50%",
        transform: "translateX(-50%)",
        width: 600,
        height: 600,
        borderRadius: "50%",
        background: "radial-gradient(circle, rgba(103,104,252,0.12) 0%, transparent 70%)",
        pointerEvents: "none",
      }} />

      <div style={{
        position: "relative",
        zIndex: 1,
        width: "100%",
        maxWidth: 420,
        padding: "0 24px",
      }}>
        {/* Logo */}
        <div style={{ textAlign: "center", marginBottom: 40 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10, marginBottom: 8 }}>
            <CrossedLogo size={32} />
            <span style={{
              fontFamily: "var(--font-space-grotesk, sans-serif)",
              fontWeight: 700,
              fontSize: 22,
              letterSpacing: "0.05em",
              color: TEXT,
            }}>
              CROSSED
            </span>
          </div>
          <p style={{ fontSize: 13, color: MUTED, margin: 0, letterSpacing: "0.02em" }}>
            Cross-platform management for independent sellers
          </p>
        </div>

        {/* Card */}
        <div style={{
          background: SURFACE,
          border: `1px solid ${BORDER}`,
          borderRadius: 16,
          padding: "40px 36px",
          boxShadow: "0 0 60px rgba(103,104,252,0.08)",
        }}>
          <h1 style={{
            fontFamily: "var(--font-space-grotesk, sans-serif)",
            fontWeight: 600,
            fontSize: 22,
            margin: "0 0 8px",
            letterSpacing: "-0.02em",
            color: TEXT,
          }}>
            Welcome back
          </h1>
          <p style={{ fontSize: 14, color: MUTED, margin: "0 0 32px", lineHeight: 1.6 }}>
            Sign in to access your sales dashboard.
          </p>

          <button
            onClick={() => signIn("google", { callbackUrl: "/dashboard" })}
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 10,
              background: V,
              color: "#fff",
              fontFamily: "var(--font-sora, sans-serif)",
              fontWeight: 600,
              fontSize: 14,
              padding: "13px 24px",
              borderRadius: 10,
              border: "none",
              cursor: "pointer",
              letterSpacing: "0.01em",
              transition: "opacity 0.15s",
            }}
            onMouseEnter={e => (e.currentTarget.style.opacity = "0.88")}
            onMouseLeave={e => (e.currentTarget.style.opacity = "1")}
          >
            <svg width="18" height="18" viewBox="0 0 48 48">
              <path fill="#fff" fillOpacity=".9" d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"/>
            </svg>
            Continue with Google
          </button>

          <div style={{
            margin: "20px 0",
            display: "flex",
            alignItems: "center",
            gap: 12,
          }}>
            <div style={{ flex: 1, height: 1, background: "rgba(255,255,255,0.06)" }} />
            <span style={{ fontSize: 12, color: MUTED }}>secure sign-in</span>
            <div style={{ flex: 1, height: 1, background: "rgba(255,255,255,0.06)" }} />
          </div>

          <p style={{ fontSize: 12, color: MUTED, margin: 0, lineHeight: 1.6, textAlign: "center", opacity: 0.7 }}>
            By signing in you grant CROSSED permission to read your Gmail for automatic sales data collection.
          </p>
        </div>
      </div>
    </div>
  );
}
